import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a duotone chip component with a label.
 *
 * @param {string} symbol - The symbol.
 * @param {string} symbolColour - The symbol colour.
 * @param {string} bgColour - The background colour.
 * @param {string} label - The label.
 * @param {boolean} showBorder - If the border should show.
 * @param {boolean} hollow - If there should only be a border and no background colour.
 * @param {string} className - Additional class name for specific uses.
 * @returns {React.JSX.Element} - The rendered chip component.
 */
export const Chip = ({
    symbol,
    symbolColour,
    bgColour,
    label,
    showBorder = true,
    hollow,
    className
}) => {
    return (
        <div className="chip">
            <div
                className="chip__square"
                style={{
                    background: hollow ? 'none' : bgColour,
                    border: showBorder ? `0.2rem solid ${bgColour}` : 'none'
                }}
            >
                <span
                    className={`chip__square-symbol ${
                        className ? className : ''
                    }`}
                    style={{ color: symbolColour }}
                >
                    {/* A dash ('-') is rendered as a slightly wider horizontal bar to match the design */}
                    {symbol === '-' ? (
                        <span
                            style={{
                                display: 'block',
                                width: '1rem',
                                height: '0.2rem',
                                background: `${symbolColour}`
                            }}
                        />
                    ) : (
                        symbol
                    )}
                </span>
            </div>
            <span className="chip__label">{label}</span>
        </div>
    );
};

Chip.propTypes = {
    symbol: PropTypes.string,
    symbolColour: PropTypes.string,
    bgColour: PropTypes.string,
    label: PropTypes.string,
    showBorder: PropTypes.bool,
    hollow: PropTypes.bool,
    className: PropTypes.string
};
